import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getCountdown } from "../helper/Countdown";
import toast from "react-hot-toast";
import productData from "../data/products.json";

const DealsOffice = () => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  // Image Handler (same logic everywhere)
  const getImage = (item) => {
    if (!item) return "/assets/img/placeholder.png";

    if (Array.isArray(item.imageUrl) && item.imageUrl.length > 0) {
      return item.imageUrl[0];
    }

    if (typeof item.imageUrl === "string" && item.imageUrl.trim()) {
      return item.imageUrl;
    }

    return "/assets/img/placeholder.png";
  };

  useEffect(() => {
    // 👉 Filter ONLY office printers
    const filtered = productData.filter(
      (item) =>
        item.category && item.category.toLowerCase().includes("office-printer")
    );

    setProducts(filtered);
  }, []);

  // Countdown
  const [timeLeft, setTimeLeft] = useState(getCountdown());
  useEffect(() => {
    const interval = setInterval(() => setTimeLeft(getCountdown()), 1000);
    return () => clearInterval(interval);
  }, []);

  // Add to cart + session check
  const handleAddToCart = (product) => {
    const isLoggedIn = sessionStorage.getItem("isLoggedIn");

    if (isLoggedIn !== "true") {
      toast.error("Please login first!");
      navigate("/login-now");
      return;
    }

    let cart = JSON.parse(sessionStorage.getItem("cart")) || [];
    const existing = cart.find((item) => item.id === product.id);

    if (existing) {
      existing.quantity++;
    } else {
      cart.push({ ...product, quantity: 1 });
    }

    sessionStorage.setItem("cart", JSON.stringify(cart));

    // 🔥 Trigger header update instantly (fixes no-refresh issue)
    window.dispatchEvent(new Event("cart-updated"));

    toast.success(`${product.name} added to cart!`);
  };

  const formatCategory = (str) =>
    str.replace(/[-_]/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());

  // Extra UI metadata (rating + random tags)
  const productsWithRandomData = useMemo(() => {
    return products.map((item) => {
      const rating = (Math.random() * 1 + 4).toFixed(1);
      const tagPool = ["Wireless", "Business Use", "High Speed", "Smart Print"];
      const features = tagPool.sort(() => 0.5 - Math.random()).slice(0, 2);

      return {
        ...item,
        rating,
        features,
        formattedCategory: formatCategory(item.category),
      };
    });
  }, [products]);

  return (
    <section className="deals-weeek pt-30 pb-30 sec-grey">
      <div className="container container-lg">
        <div className="p-24 text-center mb-30">
          <h4 style={{ fontSize: "32px", fontWeight: "700", color: "#222" }}>
            Best Office Printers You Can Trust
          </h4>
          <p
            style={{
              color: "#555",
              fontSize: "15px",
              maxWidth: "700px",
              margin: "10px auto",
              lineHeight: "1.7",
            }}
          >
            Designed for productivity, reliability, and performance – perfect
            for home offices, corporate environments, and business workflow.
          </p>
        </div>

        {/* PRODUCT GRID */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "25px",
            marginBottom: "40px",
          }}
        >
          {productsWithRandomData.map((item) => (
            <div key={item.id} className="deal-card">
              <Link to={`/product-details/${item.id}`} className="card-image">
                <img src={getImage(item)} alt={item.name} loading="lazy" />
                <span className="badge">🔥 Popular</span>
              </Link>

              <div className="card-content">
                <p className="card-category">{item.formattedCategory}</p>

                <Link to={`/product-details/${item.id}`} className="card-title">
                  {item.name}
                </Link>

                <p className="card-description">
                  {item.description
                    ? item.description.split(" ").slice(0, 12).join(" ") + "..."
                    : ""}
                </p>

                <div className="card-tags">
                  {item.features.map((tag, i) => (
                    <span key={i} className="tag">
                      {tag}
                    </span>
                  ))}
                </div>

                <div className="card-footer">
                  <div>
                    <span className="price">${item.price}</span>
                  </div>
                  <button
                    className="cart-btn"
                    onClick={() => handleAddToCart(item)}
                  >
                    Add <i className="ph ph-shopping-cart" />
                  </button>
                </div>

                <div className="card-rating">
                  <span className="stars">⭐ {item.rating}</span>
                  <span className="stock">✔ In Stock</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DealsOffice;
